module.exports = __webpack_public_path__ + "media/images/flags/64/Saint-Kitts-and-Nevis-f5af5d2c3a2029ab6d7027dec36468c1.png";